module.exports = __webpack_public_path__ + "static/pic01-9ee034a782aa688adfe885344e2dc308.jpg";